export default class Project {
  constructor() {

    $('.js-globeIcon a').on('click', function(e) {
      var area = $(e.currentTarget).attr('data-area');
      $('.js-projectTopics').children().hide();
      $('.js-projectTopics').children('.'+area).show();
      $('.js-globeIcon li').removeClass('is-active');
      $('.js-globeIcon li.'+area).addClass('is-active');
      return false;
    });

    $('.js-globeIcon li').each(function(i) {
      var area = $(this).children().attr('data-area');
      var topics = $('.js-projectTopics').children('.'+area);
      if ( topics.length < 1 ) {
        $(this).hide();
      }
    });
  }
}
